import React, { Component, useState, useEffect } from 'react';
import Select from 'react-select';
import * as ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { debug } from 'util';
import axios from 'axios';
import Configdata from './Defaultdata';
import { getmessage,wrongmsg,clearform,displayprofile } from './Dynamictable';
import {txtnullchk,isvaluenull,isvalidatemail,isvalidmob} from './validation';
import Usersession from './Usersession';
import Gpaybutton from './Gpaybutton';
export default class Paymentgetway extends Component {

    constructor(props: any) {
   	super(props);
	this.state.name = "";
	
  	}
	
    state = {
        name:"",
	url: "",
	usertyeopt:0,
    };
   
    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
    componentDidMount() {
        debugger;
     
    
    }
    typeselect(e: any){
		
		
		const eid = e.target.id;
		e.target.style.backgroundColor = 'green';
		
		e.preventDefault()

     };
    
    
megboxclose(e: any){
		const Pdivr = document.getElementById('customemsgdiv') as HTMLElement;
		Pdivr.style.display = 'none';
                
	}
 iniciatepayment(e:any){
	const tkn = localStorage.getItem("id");
        
	this.makepayments(tkn,'gpayid001',1,20);
	e.preventDefault();

        }
        makepayments(tokn:any,cod:any,sts:any,amt:any){
	 try {
            const pid = '23';
		//alert(localStorage.getItem("id"));
	        const response = axios.post(Configdata.srvurl + '/insiatepayment', {
    		token: tokn,
		procode:cod,
		pstatus:sts,
		amount:amt
		
    		
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const strimg = result.data;
		getmessage(strimg,'');
		
		});
			
              }
		
    	 }
     	 catch (e) {
           // debugger;

     	 }


	}

    
 render() {

   
     return (

         <form id="frmpaymentgetway">
	<div className="per100" id="payments">
	 <div style={{overflowX:'hidden',overflowY:'auto',height:'auto'}}>
	  <div className="search-title-bar">
                       	<div className="search-title">
			  Payment getway
			</div>
			<a href="#" onClick={e => this.megboxclose(e)} title="Profile">
			<div className="search-title-toggle" id="togglesearch">
			  X
			</div>
			</a>
	   </div>
         <div className="per100">
		<div className="per100"> 
	         <h3 style={{textAlign:'center'}}> Two points per one rupees </h3>
	        </div>
                <div className="per100"> 
	         <div style={{width:'70%',marginLeft:'10%'}}>
                     <a onClick={e => this.iniciatepayment(e)} href="#">
			<div className="intialpaybutton">
			    Pay Now
			</div>
		     </a>
		 </div>
	        </div>

	</div>

	</div>
	
	</div>
   	</form>
    
   
      );
}
}

